<template>
    <kgr-club-datev-settings-provider
        :club-id="clubId"
        :callback="onLoaded"
    >
        <template #default="clubDatevSettingsScope">
            <div
                class="animated fadeIn"
            >
                <kgr-form-scaffold
                    :pending="pending"
                    :with-back-button="false"
                    :with-primary-buttons="isEditable"
                    @primaryBtnClicked="update(clubDatevSettingsScope.reload)"
                >
                    <kgr-club-datev-settings-form
                        :error="error"
                        :datev-settings="datevSettings"
                        class="animated fadeIn"
                        @enter="update(clubDatevSettingsScope.reload)"
                    />
                </kgr-form-scaffold>
            </div>
        </template>
    </kgr-club-datev-settings-provider>
</template>

<script>
import ClubDatevExportSettingsForm from '../../../../components/datev/ClubDatevSettingsForm';
import ClubDatevSettingsProvider from '../../../../components/data-provider/ClubDatevSettingsProvider';
import ClubFinancialAccountingSettingsRepository from '../../../../js/repository/ClubFinancialAccountingSettingsRepository';
import Error from '../../../../js/model/Error';
import FormScaffold from '../../../../components/common/form/FormScaffold';

export default {
    components: {
        'kgr-club-datev-settings-form': ClubDatevExportSettingsForm,
        'kgr-club-datev-settings-provider': ClubDatevSettingsProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            datevSettings: null,
        };
    },
    methods: {
        onLoaded(loadedSettings) {
            this.datevSettings = loadedSettings;
        },
        update(reload) {
            this.pending = true;
            ClubFinancialAccountingSettingsRepository.updateDatevSettings(this.clubId, this.datevSettings)
                .then(() => {
                    this.error = new Error();
                    reload();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch(error => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
